import React from 'react';

import LinkExternalIcon from '@atlaskit/icon/core/link-external';
import { LinkMenuItem } from '@atlaskit/side-nav-items/link-menu-item';
import { useIntl } from 'react-intl';

import type { CommonDraggableSideNavItemProps, DefaultItemType } from '@townsquare/griffin-navigation/types';

import { messages } from '../messages';

// Side nav item with external link icon
export const ExternalSideNavItem = (
	props: CommonDraggableSideNavItemProps & { item: DefaultItemType },
): React.JSX.Element => {
	const { isSelected, onClick, item } = props;
	const intl = useIntl();

	return (
		<LinkMenuItem
			onClick={e => onClick(item, e)}
			isSelected={isSelected}
			href={item.path}
			elemBefore={<item.Icon label="" />}
			elemAfter={
				<LinkExternalIcon
					label={intl.formatMessage(messages.openInNewTabLabel)}
					color="currentColor"
					spacing="spacious"
					size="small"
				/>
			}
			testId={item.testId}
			hasDragIndicator={props.hasDragIndicator}
			ref={props.draggableRef}
			isDragging={props.isDragging}
			dropIndicator={props.dropIndicator}
			visualContentRef={props.visualContentRef}
		>
			{item.name}
		</LinkMenuItem>
	);
};
